import React, { type FC } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

export type SaveOutOfSyncWarningModal = {
    open: boolean;
    loading: boolean;
    message: string;
    title: string;
    objectName: string;
    onClose: () => void;
    onForceSave: () => void;
    onRefreshData: () => void;
};

export const SaveOutOfSyncWarningModal: FC<SaveOutOfSyncWarningModal> = ({
    open,
    message,
    onClose,
    onForceSave,
    onRefreshData,
    loading = false,
    title,
    objectName,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <DialogContentText>{message}</DialogContentText>

                <DialogContentText>Please choose from one of the actions below:</DialogContentText>

                <ul>
                    <li>
                        <strong>Cancel:</strong> Return to the ${objectName} without saving your changes.
                    </li>

                    <li>
                        <strong>Reload from server:</strong> Load the most recent version of the ${objectName} from the
                        server, discarding your unsaved changes.
                    </li>

                    <li>
                        <strong>Save anyway:</strong> Overwrite the ${objectName} on the server with your current
                        version.
                    </li>
                </ul>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" disabled={loading} onClick={onClose}>
                    Cancel
                </Button>

                <Button variant="outlined" disabled={loading} onClick={onRefreshData}>
                    Reload from server
                </Button>

                <Button variant="outlined" disabled={loading} onClick={onForceSave}>
                    Save anyway
                </Button>
            </DialogActions>
        </Dialog>
    );
};
